export default __webpack_public_path__ + "static/media/faq.990f27a0.png";